var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2485 27.2859C25.7962 25.16 28.1717 21.2772 28.1717 16.8382H28.1688C28.1688 10.0576 22.6259 4.57402 15.8258 4.66769C9.14487 4.76135 3.74675 10.3102 3.82905 16.9914C3.88298 21.3369 6.21308 25.1316 9.68411 27.2405C9.91116 27.3796 10.2007 27.2206 10.2007 26.9538V16.9318C10.2007 13.7502 12.7209 11.0907 15.9024 11.0368C19.1521 10.9828 21.803 13.6026 21.803 16.8382C21.803 19.3841 20.1625 21.5469 17.8835 22.3274C17.6508 22.4069 17.5797 22.6992 17.7473 22.8781L21.8313 27.2263C21.9392 27.3398 22.1123 27.3681 22.2485 27.2859Z",
    fill: "#DE3341"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketTitle);
export default __webpack_public_path__ + "static/media/rocket-title.c0c15e969347ea5d14213cd053b67627.svg";
export { ForwardRef as ReactComponent };